if (!customElements.get('before-after-product')) {
  class BeforeAfterProduct extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.w-before-after-product');
      this.grids = Array.from(this.querySelectorAll('.w-before-after-product__grid'));

      this.querySelectorAll('[data-before-after]').forEach((card) => this.initCard(card));

      this.onVariantChange = (event) => this.showGridForVariant(event.detail?.variant?.id);
      document.addEventListener('on:variant:change', this.onVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('on:variant:change', this.onVariantChange);
    }

    /**
     * Shows the comparisons of the selected variant, falling back to the default shortlist,
     * and hides the whole section when neither exists.
     */
    showGridForVariant(variantId) {
      if (!variantId) return;

      const id = String(variantId);
      const target =
        this.grids.find((grid) => (grid.dataset.variantIds || '').split(',').includes(id)) ||
        this.grids.find((grid) => grid.dataset.set === 'default');

      this.grids.forEach((grid) => {
        grid.hidden = grid !== target;
      });
      if (this.section) this.section.hidden = !target;
    }

    initCard(card) {
      const handle = card.querySelector('.w-before-after-product__handle');

      const setPosition = (value) => {
        const position = Math.min(100, Math.max(0, value));
        card.style.setProperty('--position', `${position}%`);
        handle.setAttribute('aria-valuenow', Math.round(position));
      };

      const positionFromEvent = (event) => {
        const rect = card.getBoundingClientRect();
        setPosition(((event.clientX - rect.left) / rect.width) * 100);
      };

      card.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        card.setPointerCapture(event.pointerId);
        positionFromEvent(event);
      });

      card.addEventListener('pointermove', (event) => {
        if (card.hasPointerCapture(event.pointerId)) positionFromEvent(event);
      });

      handle.addEventListener('keydown', (event) => {
        const current = Number(handle.getAttribute('aria-valuenow'));
        const step = event.shiftKey ? 10 : 2;
        const keys = {
          ArrowLeft: current - step,
          ArrowDown: current - step,
          ArrowRight: current + step,
          ArrowUp: current + step,
          Home: 0,
          End: 100,
        };
        if (!(event.key in keys)) return;
        event.preventDefault();
        setPosition(keys[event.key]);
      });
    }
  }

  customElements.define('before-after-product', BeforeAfterProduct);
}
